export default "__VITE_ASSET__Bk1Yf$d___"